/**
 * Case-insensitive unique filter for applicable outcome keys (first casing wins).
 * Used when hydrating API payloads so Galactus append regressions do not multiply chips.
 */
export function uniqueApplicableOutcomeKeys(
  keys: string[] | undefined | null
): string[] {
  if (!keys?.length) return [];

  const seen = new Set<string>();
  const result: string[] = [];

  for (const raw of keys) {
    const key = raw.trim();
    if (!key) continue;
    const lower = key.toLowerCase();
    if (seen.has(lower)) continue;
    seen.add(lower);
    result.push(key);
  }

  return result;
}
